<template>
    <div class="row weekday-calendar" :class="{ 
            'moderator': adminMode,
            'client': !adminMode,
            'week-calendar': weekMode,
            'day-calendar': !weekMode,
        }">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-12 col-sm-3">
                    <h1>{{ product.name }}</h1>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <div class="form-group"
                        style="position: sticky;top: 15px;z-index: 10;"
                        :class="{ 'hidden': !resourceSelectorVisible }">
                        <select class="form-control" 
                                v-model="selectedResourceId">
                            <option v-for="(table, index) in resources" 
                                    :key="index"
                                    :value="table.resourceId">
                                {{ table.title }}
                                <span v-if="table.freeBlocks">({{ table.freeBlocks }} {{ $_locale('free', false) }})</span>
                            </option>
                        </select>
                    </div>
                    <div class="weekmode-dayselector"
                        style="position: sticky;top: 15px;z-index: 10;margin-bottom: 15px;"
                        :class="{ 'hidden': !weekdaySelectorVisibile }">
                        <div class="btn-group btn-group-sm" role="group" aria-label="Viikonpäivät">
                            <button 
                                type="button" 
                                class="btn btn-default"
                                :class="{ active: table.id == selectedWeekday }"
                                v-for="(table, index) in timeTableRows" 
                                :key="index"
                                @click="selectedWeekday = table.id"
                            >{{ table.shortTitle }}</button>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-3">
                    <div class="alert alert-info calendar-modifiers" 
                            role="alert" 
                            style="cursor:pointer;">
                        <div v-if="admin" 
                            class="calendar-modifier-clientmode"
                            @click="toggleAdminMode" role="button">
                            {{ $_locale('client order mode') }}: <span>
                            <b v-if="!adminMode">{{ $_locale('on') }}</b>
                            <b v-if="adminMode">{{ $_locale('off') }}</b>
                            </span>
                        </div>
                        <div @click="toggleWeekMode" 
                            class="calendar-modifier-viewmode"
                            role="button">
                            {{ $_locale('week view mode') }}: <span>
                                <b v-if="weekMode">{{ $_locale('on') }}</b>
                                <b v-if="!weekMode">{{ $_locale('off') }}</b>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-3 datepicker-master">
                    <button class="btn btn-xs btn-default" @click="adjustDate(-1)">
                        <i class="glyphicon glyphicon-chevron-left"></i>
                    </button>
                    <input type="text" class="form-control" ref="dateInput" style="margin: 0 7px;" />
                    <button class="btn btn-xs btn-default" @click="adjustDate(1)">
                        <i class="glyphicon glyphicon-chevron-right"></i>
                    </button>
                </div>
                <div class="col-xs-12 reservation-product-description" 
                        :class="{'hidden': mobile === true}"
                        v-html="product.description">
                </div>
                <div class="col-xs-12">
                    <div class="pull-right">
                        <button v-if="adminMode"
                            @click="$store.commit('common/setModal', 'resourcecommentmodal')"
                            class="btn btn-sm btn-default pull-right openuserteetimes" 
                            style="margin-right: 7px;">
                            {{ $_locale('comments') }}
                        </button>
                        <button v-if="!adminMode"
                            @click="$store.commit('common/setModal', 'userreservations')"
                            class="btn btn-sm btn-default pull-right openuserteetimes" 
                            style="margin-right: 7px;">
                            {{ $_locale('reservations') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12">
            <div v-if="!isInvalidDate(date)" 
                class=""
                :class="{
                    'admin-mode': adminMode,
                    'client-mode': !adminMode,
                    'week-mode': weekMode,
                    'day-mode': !weekMode,
                    'reservation-table': VIEW_MODES.calendar == selectedViewMode,
                    'grid-reservation-table': VIEW_MODES.calendar != selectedViewMode,
                    'show-names-public': showNamesPublic,
                }"
                style="margin-bottom: 20px;padding-top: 40px;">
                <div class="resource-titles">
                    <div v-for="(table, index) in timeTableRows"
                        :key="index" 
                        :class="[
                            'resource-title-'+table.resourceId, 
                            !isColumnVisible(weekMode ? table.id : table.resourceId) ? 'hidden' : ''
                        ]">{{ table.title }}</div>
                </div>
                <div class="base" v-if="!disabled">
                    <div v-if="dateChangeInProgress" style="position:absolute;top:0;left:0;width: 100%;height:100%;min-height:450px;z-index: 10;">
                        <div class="spinner-master" style="">
                            <div style="">
                                <i class="glyphicon glyphicon-refresh spin"></i>
                            </div>
                        </div>
                    </div>
                    <div class="basetimetable">
                        <div class="time"
                            v-for="(time, index) in baseTimeTable" :key="index">
                            <span class="title">{{ $_formatDateTime($_dateFormat.DATETIME_HI, time.start) }}</span>
                        </div>
                    </div>
                    <div class="time-blocks">
                        <table-column :class="['time-column-'+table.resourceId]"
                            v-for="(table, index) in timeTableRows"
                            :key="index" 
                            :hidden="!isColumnVisible(weekMode ? table.id : table.resourceId)" 
                            :table="table"></table-column>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12" 
            :class="{'hidden': mobile !== true}"
            v-html="product.description">
        </div>
        <ConfirmationModal 
            @processing="(val) => val ? $refs.spinner.open() : $refs.spinner.close()" />
        <EditReservationModal />
        <ListReservationsModal />
        <ReservationsUserModal />
        <ReservationUserDisplayModal />
        <ResourceCommentModal 
            v-if="resources.length > 0" 
                :resource="resources[0]"
                :resources="resources" />
        <HandlingSpinner ref="spinner" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ReservationsUserModal from './ReservationsUserModal.vue'
import ReservationUserDisplayModal from './ReservationUserDisplayModal.vue'
import ResourceCommentModal from '../common/ResourceCommentModal.vue'
import { TIMEBLOCK_TYPE } from '../common/ReservationService.js'

const { formatDateTime, dateFormat, getDateFormat } = window.wisenetwork;

export default {
    components: {
        ReservationsUserModal,
        ReservationUserDisplayModal,
        ResourceCommentModal,
    },
    data: () => ({
        selectedResourceId: 0,
        selectedWeekday: 0,
    }),
    computed: {
        ...mapGetters({
            date: 'reservations/date',
            dateChangeInProgress: 'reservations/dateChangeInProgress',
            weekMode: 'reservations/weekMode',
            isInvalidDate: 'reservations/isInvalidDate',
            selectedViewMode: 'calendar/selectedViewMode',
            VIEW_MODES: 'calendar/VIEW_MODES',
            timeTable: 'calendar/timeTable',
            baseTimeTable: 'calendar/baseTimeTable',
            product: 'ecom/product',
            admin: 'common/admin',
            adminMode: 'common/adminMode',
            mobile: 'common/mobile',
            disabled: 'reservations/disabled',
            dateRestrictions: 'reservations/dateRestrictions',
            showNamesPublic: 'reservations/showNamesPublic',
        }),
        timeTableRows() {
            if (!this.weekMode) {
                return this.timeTable;
            }
            
            const timeTable = this.timeTable.filter(row => row.resourceId === this.selectedResourceId)[0];
            const restrictions = this.dateRestrictions;
            
            if (!timeTable || !timeTable.days) {
                return []
            }
            
            return timeTable.days.map((dayObj, i) => {
                if ((!!restrictions.start && dayObj.date < restrictions.start)
                    || (!!restrictions.end && dayObj.date > restrictions.end)) {
                    dayObj.timeBlocks = [];
                }
                return dayObj;
            });
        },
        resources() {
            const weekMode = this.weekMode;
            const timeTable = this.timeTable;

            if (weekMode) {
                return timeTable;
            }

            return timeTable.map(row => {
                const { resourceId, title, timeBlocks } = row;
                const futureBlocks = timeBlocks.filter(
                    row => row.past === false && row.reservations.length === 0
                    && [
                        TIMEBLOCK_TYPE.disabled, 
                        TIMEBLOCK_TYPE.disabledByRule
                    ].includes(row.type) === false
                )

                return {
                    resourceId,
                    title,
                    freeBlocks: futureBlocks.length
                }
            })
        },
        resourceSelectorVisible() {
            if (this.weekMode) return true;
            if (!this.mobile) return false;
            if (this.timeTable.length === 1) return false;

            return true;
        },
        weekdaySelectorVisibile() {
            if (!this.mobile) return false;
            if (!this.weekMode) return false;

            return true;
        },
        isColumnVisible() {
            return (id) => {
                if (!this.mobile) return true;
                
                if (this.weekMode) {
                    return this.selectedWeekday == id;
                }

                return this.selectedResourceId == id;
            }
        }
    },
    methods: {
        toggleAdminMode() {
            this.$store.commit('common/toggleAdminMode')
            this.$store.commit('reservations/setServiceAdminMode', this.adminMode);
            
            this.$store.dispatch('reservations/onDateChange', this.date)
                .then(() => {
                    this.$emit('adminToggle')
                })
        },
        toggleWeekMode() {
            this.$store.commit('reservations/toggleWeekMode')
            this.$store.dispatch('reservations/onWeekModeChange')
        },
        adjustDate(value) {
            const input = this.$refs.dateInput
            const picker = input._daterangepicker
            const date = this.date.clone().add(value, this.weekMode ? 'weeks' : 'days')
            
            if (picker) {
                picker.setStartDate(date);
                picker.setEndDate(date);
            } else {
                console.warn('daterangepicker not initialized')
            }
            
            this.$store.dispatch('reservations/onDateChange', date);
        },
        initDatepicker() {
            const { daterangepicker } = window.wisenetwork
            const input = this.$refs.dateInput;
            const dayNameShort = getDateFormat(dateFormat.DATETIME_DAY_NAME_SHORT);
            const dayFormat = getDateFormat(dateFormat.DATETIME_DMY);
            const format = this.weekMode ? `[${ _locale('week').ucfirst() }] w` : dayNameShort+' '+dayFormat;
            const startDate = this.$store.getters['reservations/startDate'];
            let date = this.date;
            
            if (startDate > date) {
                date = startDate;
            }

            if (this.mobile) {
                input.readOnly = true;
            }
            
            const picker = daterangepicker(
                input,
                {
                    locale: { 
                        format,
                        daysOfWeek: _localeDates.dayNamesMin,
                        monthNames: _localeDates.monthNamesShort,
                        firstDay: 1,
                    },
                    opens: 'right',
                    showWeekNumbers: true,
                    singleDatePicker: true,
                    showDropdowns: true,
                    startDate: date,
                    isInvalidDate: (date) => this.isInvalidDate(date)
                }, 
                (startDate, endDate) => {
                    this.$store.dispatch('reservations/onDateChange', startDate)
                }
            )

            if (moment().format('YYYY-MM-DD') !== date.format('YYYY-MM-DD')) {
                const toggleFocus = (pulse) => {
                    if (pulse <= 0) return;

                    if (input.classList.contains('input-focus')) {
                        input.classList.remove('input-focus')
                    } else {
                        input.classList.add('input-focus')
                    }

                    setTimeout(() => toggleFocus(pulse - 1), 600)
                }

                setTimeout(() => toggleFocus(6), 600)
            }
        }
    },
    watch: {
        mobile(val) {
            /*
            if (val && this.weekMode) {
                this.toggleWeekMode();
            }
            */
        },
    },
    mounted() {        
        this.$nextTick(() => {
            this.initDatepicker()

            const resources = [ ...this.resources ].sort(
                (a, b) => {
                    if (a.freeBlocks === b.freeBlocks) {
                        return a.resourceId > b.resourceId ? 1 : -1;
                    }

                    return a.freeBlocks < b.freeBlocks ? 1 : -1;
                }
            )
            
            this.selectedResourceId = resources[0].resourceId;
            this.selectedWeekday = moment().day();
        })
    }
}
</script>

<style scoped>
.input-focus {
    border-color: #66afe9;
    outline: 0;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
}
</style>